import {
  GET_ASSETINSPECTION,
  GET_ASSETINSPECTION_SUCCESS,
  GET_ASSETINSPECTION_FAIL,
  DELETE_ASSETINSPECTION,
  DELETE_ASSETINSPECTION_SUCCESS,
  DELETE_ASSETINSPECTION_FAIL,
  UPDATE_ASSETINSPECTION,
  UPDATE_ASSETINSPECTION_SUCCESS,
  UPDATE_ASSETINSPECTION_FAIL,
  ADD_NEW_ASSETINSPECTION,
  ADD_ASSETINSPECTION_SUCCESS,
  ADD_ASSETINSPECTION_FAIL,
  ASSETINSPECTION_LOADING,
  ASSETINSPECTION_RESET,
  ASSETINSPECTION_RESET_CREATE
} from "./actionType";

export const resetAssetInspectionState = (actionType) => ({
  type: ASSETINSPECTION_RESET,
  payload: { actionType },
});


export const resetAssetInspectionCreateState = (actionType) => ({
  type: ASSETINSPECTION_RESET_CREATE,
  payload: { actionType }
});

export const getAssetInspectionSuccess = (actionType, data) => ({
  type: GET_ASSETINSPECTION_SUCCESS,
  payload: { actionType, data },
});

export const getAssetInspectionFail = (actionType, error) => ({
  type: GET_ASSETINSPECTION_FAIL,
  payload: { actionType, error },
});

export const getAssetInspection = data => ({
  type: GET_ASSETINSPECTION,
  payload: data,
});

export const getAssetInspectionLoading = () => ({
  type: ASSETINSPECTION_LOADING
});

export const deleteAssetInspection = data => ({
  type: DELETE_ASSETINSPECTION,
  payload: data,
});

export const deleteAssetInspectionSuccess = data => ({
  type: DELETE_ASSETINSPECTION_SUCCESS,
  payload: data,
});

export const deleteAssetInspectionFail = error => ({
  type: DELETE_ASSETINSPECTION_FAIL,
  payload: error,
});

export const updateAssetInspection = data => ({
  type: UPDATE_ASSETINSPECTION,
  payload: data,
});

export const updateAssetInspectionFail = error => ({
  type: UPDATE_ASSETINSPECTION_FAIL,
  payload: error,
});

export const updateAssetInspectionSuccess = data => ({
  type: UPDATE_ASSETINSPECTION_SUCCESS,
  payload: data,
});

export const addNewAssetInspection = data => ({
  type: ADD_NEW_ASSETINSPECTION,
  payload: data,
});

export const addAssetInspectionSuccess = data => ({
  type: ADD_ASSETINSPECTION_SUCCESS,
  payload: data,
});

export const addAssetInspectionFail = error => ({
  type: ADD_ASSETINSPECTION_FAIL,
  payload: error,
});